import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { SubdomainService } from './subdomain.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiBaseUrl;
  private tokenKey = 'x-access-token';
  private userKey = 'user-data';

  constructor(
    private http: HttpClient,
    private router: Router,
    private apiService: ApiService,
    private subdomainService: SubdomainService
  ) {}

  login(username: string, password: string): Observable<any> {
    let subdomain = this.subdomainService.getSubdomain();
    return this.http
      .post<any>(`${this.apiUrl}/api/auth/signin`, {
        username,
        password,
        subdomain,
      })
      .pipe(
        map((response) => {
          // Store token in localStorage
          console.log(response.accessToken);
          localStorage.setItem(this.tokenKey, response.accessToken);
          
          // Store user data in localStorage
          const userData = {
            id: response.id,
            username: response.username,
            email: response.email,
            roles: response.roles
          };
          localStorage.setItem(this.userKey, JSON.stringify(userData));
          
          // Set the auto-logout timer
          this.setLogoutTimer();
          return response;
        })
      );
  }

  logout(): void {
    // Remove token and user data from localStorage
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    this.router.navigate(['auth', 'login']);
  }

  isVerifiedToken(): boolean {
    this.http.get<any>(`${this.apiUrl}/api/auth/verifyToken`).subscribe(
      (message) => {},
      (error) => {
        return false;
      }
    );
    return true;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  private setLogoutTimer(): void {
    const expirationTime = 84350; // seconds
    setTimeout(() => {
      this.logout();
    }, expirationTime * 1000); // Convert seconds to milliseconds
  }
}
